import axios from "axios";
import { observable, action, computed, configure } from "mobx";
// import { GoogleAuth } from 'google-auth-library';

configure({ enforceActions: true });

/*
 * Google Sign-In for Websites: https://developers.google.com/identity/sign-in/web/devconsole-project
 * Google Sign-In JavaScript client reference: https://developers.google.com/identity/sign-in/web/reference
 * New: https://developers.google.com/identity/gsi/web/guides/get-google-api-clientid
 */

export class AuthStore {
  @observable initialized = false;

  @action setInitialized = initialized => (this.initialized = initialized);

  @observable loading = false;

  @action setLoading = loading => (this.loading = loading);

  @observable
  authUser = {
    id: null,
    email: null,
  };

  @action
  setAuthUser = authUser => {
    this.authUser = authUser ? { ...authUser } : {};
  };

  @computed
  get isUserSignedIn() {
    return this.authUser.id;
  }

  @computed
  get userId() {
    return this.authUser.id;
  }

  @computed
  get userEmail() {
    return this.authUser.email;
  }

  @observable buildInfo;
  @action setBuildInfo = buildInfo => (this.buildInfo = buildInfo);
}

const authStore = new AuthStore();

const CLIENT_ID = "244041232493-8gf1stc5h8e9rmf2u892ivgm4ndrqlgr.apps.googleusercontent.com"; //jabotxtest@gmail.com's client ID
// const CLIENT_ID = "295304158258-h9pj911kctn6faig4fv376k25hpvmtf2.apps.googleusercontent.com"; //Martinov CLIENT_ID

// let googleAuth = null;
let loggedUserGoogleToken = null;

//Potrebujem https://accounts.google.com/gsi/client nacitat ako scrit v index.html
//aby som mohol pouzit metodu initGoogleSignInButton() v LoginScreen.js na inicializaciu login buttonu.
//Cakal by som ze tu to uz potrebovat nebudem a staci zavolat len initializeGoogleAuth()
//ale nejde to tak, musi to byt aj tu takto dynamicky loadovane inak to nejde.
//Netusim preco, toto ide tak to neriesim ...
const script = document.createElement("script");
script.src = "https://accounts.google.com/gsi/client";
script.onload = initializeGoogleAuth;
document.head.appendChild(script);
// initializeGoogleAuth();

export function initializeGoogleAuth() {
  if (typeof window.google === "undefined") {
    console.error(
      "window.google is undefined. Probably google sign-in script (https://accounts.google.com/gsi/client) was not read correctly."
    );
    return;
  }

  //https://developers.google.com/identity/gsi/web/reference/js-reference
  window.google.accounts.id.initialize({
    client_id: CLIENT_ID,
    ux_mode: "popup",
    callback: handleGoogleAuthCallback,
  });

  window.google.accounts.id.prompt(notification => {
    if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
      authStore.setInitialized(true);
      console.log("User is not logged in", notification);
    }
  });

  initGoogleSignInButton();
}

export function initGoogleSignInButton() {
  window.google.accounts.id.renderButton(document.getElementById("btnGoogleSignIn"), {
    type: "standard",
    logo_alignment: "left",
    theme: "outline",
    text: "continue_with",
    shape: "circle",
    size: "large",
  });
}

export async function handleGoogleAuthCallback(response) {
  authStore.setInitialized(true);

  if (response.credential) {
    console.log("Google Login successfull. Response:", response);
    loggedUserGoogleToken = response.credential;

    authStore.setLoading(true);

    const axiosRequest = axios.create({
      baseURL: "api",
      headers: {
        Accept: "application/json",
        ...getAuthHttpHeaders(),
      },
    });

    try {
      const response = await axiosRequest.get("user/me");
      console.log("users/me response", response);
      authStore.setAuthUser(response.data);

      try {
        const responseBuildInfo = await axiosRequest.get("system/buildInfo", { headers: { ...getAuthHttpHeaders() } });
        console.log("system/buildInfo response", responseBuildInfo);
        authStore.setBuildInfo(responseBuildInfo.data);
      } catch (bie) {
        console.error(bie);
      }
    } catch (e) {
      window.alert("Login failed");
      authStore.setAuthUser(null);
      console.error(e);
    }

    authStore.setLoading(false);
  } else {
    console.log("Google Login was not successfull");
    authStore.setAuthUser(null);
  }
}

export function getAuthHttpHeaders() {
  if (loggedUserGoogleToken) {
    return {
      Authorization: `Bearer ${loggedUserGoogleToken}`,
    };
  }

  return {};
}

export async function signOut() {
  window.google.accounts.id.disableAutoSelect();
  authStore.setAuthUser(null);
  console.log("Google user signed out.");
}

export default authStore;



// WEBPACK FOOTER //
// ./src/auth.js